import { IRadioItem } from "../../../Common/UI/RadioButton/Types";

export enum RecursTypes {
  Daily = "daily",
  Weekly = "weekly",
  Monthly = "monthly",
  Quarterly = "quarterly",
  Yearly = "yearly"
}

export enum WeekOfTheMonthTypes {
  First,
  Second,
  Third,
  Fourth
}

export const WeekOfTheMonthTypesText = {
  [WeekOfTheMonthTypes.First]: "First",
  [WeekOfTheMonthTypes.Second]: "Second",
  [WeekOfTheMonthTypes.Third]: "Third",
  [WeekOfTheMonthTypes.Fourth]: "Fourth"
};

export const dayRadioOption: IRadioItem[] = [
  {
    text: "Day",
    value: "1"
  },
  {
    text: "The",
    value: "2"
  }
];
